/* eslint-disable react/jsx-pascal-case */
import React from 'react';

import { Table } from 'components/MRT';
import { MarketsTableData } from 'api/selectors/pages';

import { columns } from './BadMarketsTableColumns';

export function BadMarketsTable({ tableData }: { tableData: MarketsTableData[] }) {
  return (
    <Table<MarketsTableData>
      initialState={{
        density: 'compact',
        columnOrder: ['market', 'rating', 'tvl', 'links'],
      }}
      autoPinningColumns={['market']}
      data={tableData}
      columns={columns}
      enablePinning={false}
      enableTopToolbar={false}
      enableBottomToolbar={false}
      enableRowActions={false}
      enablePagination={false}
    />
  );
}
